import React from "react";
import "../styles/components/BrandName.scss";

function BrandName({ isFooter = false }) {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      scrollToTop();
    }
  };
  return (
    <div
      className={`brand ${isFooter === true ? "footer" : ""}`}
      onClick={scrollToTop}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label="riverpoint — scroll to top"
    >
      <span className="brand-badge" aria-hidden="true">
        R
      </span>
      <span className="brand-word">
        <span className="brand-river">river</span>
        <span className="brand-point">point</span>
      </span>
    </div>
  );
}

export default BrandName;
